import * as React from 'react';

import * as analytics from '@gitbook/app-analytics/client';
import type { HiveWorkingDocument } from '@gitbook/hive-client';

// Global variable, but only used in a browser callback.
const trackedPages = new Set<string>();

/**
 * Track the event `edit_page_document_start` when the user starts editing a hive document.
 * It's only tracked once per page during the entire session.
 */
export function useAnalyticsTrackStartEdit(props: {
    hivePage: HiveWorkingDocument;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
}): () => void {
    const { hivePage, analyticsContext } = props;

    return React.useCallback(() => {
        const id = `${hivePage.contentId}/${hivePage.branchId}/${hivePage.containerId}`;
        if (trackedPages.has(id)) {
            return;
        }
        trackedPages.add(id);

        if (hivePage.containerType === 'pages') {
            analytics.logEvent({
                ...analyticsContext,
                page: hivePage.containerId,
                type: 'edit_page_document_start',
                collaborators: hivePage.dataSync.presences.length,
            });
        }
    }, [hivePage, analyticsContext]);
}
